let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("89XXa")).then(() => parcelRequire('h7KBK'));